import React, { useEffect, useRef } from "react";
import Sidebar from "../sidebar/sidebar";
import { useSidebar } from "../../context/sidebar";
import axios from "axios";
import { backendURL } from "../../utils/backed-url";

const AuthedPageLayout = ({ children }) => {
  const { setIsOpen } = useSidebar();

  const closeSidebar = () => {
    setIsOpen(false);
  };

  const setBackendToken = async (token) => {
    try {
      const d = await axios.post(
        `${backendURL}/v1/api/register-device/`,
        {
          token,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log(d);
    } catch (e) {
      console.log(e);
    }
  };

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const token = localStorage.getItem("fcmToken");
    if (token) {
      setBackendToken(token);
    }
  }, []);

  return (
    <div className="authed-page">
      <div className="authed-page__top-nav" />
      <div className="authed-page__body">
        <div className="authed-page__sidebar">
          <Sidebar />
        </div>
        <div
          className="authed-page__content-wrapper"
          id="authed-page"
          onClick={closeSidebar}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthedPageLayout;
